import { defineStore } from 'pinia'
import { useLocalStorage } from '@vueuse/core/index.cjs';

const usuario = (params = {}) =>{
    return{
        id: params.userId || "",
        nome: params.user || "",
        login: params.username || "",
        grupoId: params.groupId || "",
        grupoNome: params.groupName || "",
        tokenAcesso: params.accessToken || "",
        tokenAPI: params.apiKey || "",
    }
}

const useUsuarioStore = defineStore('UsuarioStore', {
    state: () => ({
        usuario: useLocalStorage("UsuarioStore", usuario())
    }),
    actions: {
        save(params) {
            this.usuario = usuario(params);
        },
        clear() {
            this.usuario = usuario();
        },
    },
});

export default useUsuarioStore